import React from 'react'
import CeoDummy from "../images/dummyCeo.png"
import "../styles/CeoMessage.css"
function CeoMessage() {
  return (
    <>
    <section className="ceo-message-section">
        <div className="container">
            <div className="ceo-message-box">
                <picture>
                    <img src={CeoDummy} alt="" />
                </picture>
                <h2>Dr. Mohamed Abdelkhalek</h2>
                <p>
                    "Welcome to Cairomed, a leading provider of specialized poultry
                    products in Egypt. With a deep understanding of the unique
                    challenges faced by the poultry industry, we are dedicated to
                    delivering high-quality products that promote the health and
                    well-being of poultry across the country."</p>
            </div>
            <div className="ceo-message-box">
                <picture>
                    <img src={CeoDummy} alt="" />
                </picture>
                <h2>Eng. Belal ElShehaby</h2>
                <p>
                    "Welcome to Cairomed, a leading provider of specialized poultry
                    products in Egypt. With a deep understanding of the unique
                    challenges faced by the poultry industry, we are dedicated to
                    delivering high-quality products that promote the health and
                    well-being of poultry across the country."</p>
            </div>
        </div>
    </section>
    </>
  )
}

export default CeoMessage